if (window.CDN_URL.startsWith('https://')) {
  __webpack_public_path__ = `${window.CDN_URL}/`;
}
